/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */
const timestampToTime = (timestamp) => {
    let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-'
    let M =
        (date.getMonth() + 1 < 10 ?
            '0' + (date.getMonth() + 1) :
            date.getMonth() + 1) + '-'
    let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
    let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
    return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
    if (!name) return
    if (typeof content !== 'string') {
        content = JSON.stringify(content);
    }
    window.localStorage.setItem(name, content);
}

const setTimeStore = (name, content, expires = 0) => {
    if (!name) return;
    const now = new Date()
    const obj = {
        value: content,
        expires: expires > 0 ? now.getTime() + (expires * 1000) : 0
    };
    window.localStorage.setItem(name, JSON.stringify(obj));
}

/**
 * 获取localStorage
 */
const getStore = name => {
    if (!name) return
    return window.localStorage.getItem(name);

}

const getTimetore = name => {
    if (!name) return null;
    const dataStr = window.localStorage.getItem(name);
    if (!dataStr) return null;
    try {
        const data = JSON.parse(dataStr);
        if (data.expires > 0 && Date.now() > data.expires) {
            removeStore(name);
            return null;
        }
        return data.value;
    } catch (e) {
        return dataStr;
    }
}

/**
 * 删除localStorage
 */
const removeStore = name => {
    if (!name) return
    window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
    let date = new Date();
    date.setDate(date.getDate() + day);
    document.cookie = name + '=' + value + ';expires=' + date;
}

/**
 * 获取cookie
 **/
function getCookie(name) {
    let reg = RegExp(name + '=([^;]+)');
    let arr = document.cookie.match(reg);
    if (arr) {
        return arr[1];
    } else {
        return ''
    }
}

/**
 * 删除cookie
 **/
function delCookie(name) {
    setCookie(name, null, -1);
}

/**
 * 深拷贝函数
 * @param {*} source 要拷贝的数据
 * @returns {*} 深拷贝后的新数据
 */
const deepClone = (source) => {
    // 基本数据类型直接返回
    if (source === null || typeof source !== 'object') {
        return source
    }

    // 处理日期对象
    if (source instanceof Date) {
        return new Date(source.getTime())
    }

    // 处理数组
    if (Array.isArray(source)) {
        return source.map(item => deepClone(item))
    }

    // 处理普通对象
    const cloneObj = {}
    for (const key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
            cloneObj[key] = deepClone(source[key])
        }
    }
    return cloneObj
}

/**
 * 防抖函数
 * @param {Function} fn 要执行的函数
 * @param {number} wait 等待时间(毫秒)
 * @param {boolean} immediate 是否立即执行
 * @returns {Function} 防抖处理后的函数
 */
const debounce = (fn, wait = 300, immediate = false) => {
    let timeoutId = null;

    return function (...args) {
        const context = this;

        // 清除已有定时器
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }

        // 立即执行模式
        if (immediate && !timeoutId) {
            fn.apply(context, args);
        }

        // 设置新的定时器
        timeoutId = setTimeout(() => {
            if (!immediate) {
                fn.apply(context, args);
            }
            timeoutId = null;
        }, wait);
    };
};


/**
 * 导出 
 **/
export {
    timestampToTime,
    setStore,
    setTimeStore,
    getStore,
    getTimetore,
    removeStore,
    setCookie,
    getCookie,
    delCookie,
    deepClone,
    debounce
}